// Convierte el error de una petición en texto para mostrar al usuario.
// El backend a veces manda `error` como objeto ({ campo: ['mensaje'] }); renderizar
// un objeto directamente en React rompe la página (pantalla en blanco).
const toText = (value) => {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) return value.map(toText).filter(Boolean).join(' ');
  if (typeof value === 'object') {
    return Object.entries(value)
      .map(([field, msg]) => {
        const text = toText(msg);
        return field === 'non_field_errors' || field === 'detail' ? text : `${field}: ${text}`;
      })
      .filter(Boolean)
      .join('; ');
  }
  return String(value);
};

export const getErrorMessage = (err, fallback = 'Ocurrió un error inesperado') => {
  const data = err?.response?.data;
  return toText(data?.error) || toText(data?.detail) || toText(data?.message) || err?.message || fallback;
};

export const errorToText = toText;
